import React from 'react';
import { createComponent } from '@lit/react';
import { SDSHeading } from '../sds-heading/sds-heading';

export const SDSHeadingWrapper = createComponent({
	tagName: 'sds-heading',
	elementClass: SDSHeading,
	react: React,
	events: {},
});
